import { InfoCircleOutlined, TeamOutlined } from '@ant-design/icons';
import { Space, Tag, Tooltip, Typography } from 'antd';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Organization } from '../../../../../../../model/types';

const { Text } = Typography;

const OrganizationInfoContainer = ({ organizationData }: { organizationData: Organization }) => {
    const { t } = useTranslation('organizations');

    return (
        <Space direction="vertical" className="full-width">
            <Tooltip placement="right" title={t('notes.tooltip')}>
                <Space size="middle">
                    <InfoCircleOutlined />
                    <Text>{organizationData?.notes ?? '-'}</Text>
                </Space>
            </Tooltip>
            <Tooltip placement="right" title={t('details.tooltip')}>
                <Space size="middle">
                    <InfoCircleOutlined />
                    <Text>{organizationData?.details ?? '-'}</Text>
                </Space>
            </Tooltip>
            <Tooltip placement="right" title={t('group.tooltip')}>
                <Space size="middle">
                    <TeamOutlined />
                    <Space size={5} wrap>
                        {organizationData?.group && (
                            <Tag key={organizationData?.group?.id}>{organizationData?.group?.name}</Tag>
                        )}
                    </Space>
                </Space>
            </Tooltip>

            {/* <Tooltip placement="right" title={t('group.tooltip')}>
                <Space size="middle">
                    <TeamOutlined />
                    <Space size={5} wrap>
                        {organizationData?.groups?.map(({ id, name }) => (
                            <Tag key={id}>{name}</Tag>
                        ))}
                    </Space>
                </Space>
            </Tooltip> */}

            {/* <Tooltip placement="right" title={t('tags')}>
                <Space size="middle">
                    <TagOutlined />
                    <Space size={5} wrap>
                        {organizationData?.tags?.map((tag) => (
                            <Tag key={tag}>{tag}</Tag>
                        ))}
                    </Space>
                </Space>
            </Tooltip> */}
        </Space>
    );
};

export default observer(OrganizationInfoContainer);
